/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.16.0 (NJsonSchema v9.10.56.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming


export interface LunaCodeNode {
    nodeType?: NodeKind | null;
    line?: number | null;
    column?: number | null;
    
}

export interface WhenNode extends LunaCodeNode {
    condition?: LunaCodeNode | null;
    result?: LunaCodeNode | null;
}

export enum NodeKind{
    ArgumentNode = "ArgumentNode", 
    ArithmeticNode = "ArithmeticNode", 
    BooleanLiteral = "BooleanLiteral", 
    BooleanLogicNode = "BooleanLogicNode", 
    LiteralNode = "LiteralNode", 
    CaseNode = "CaseNode", 
    DateLiteral = "DateLiteral", 
    FunctionNode = "FunctionNode", 
    IfNode = "IfNode", 
    InNode = "InNode", 
    IsNullNode = "IsNullNode", 
    LikeNode = "LikeNode", 
    NotNode = "NotNode", 
    NullLiteral = "NullLiteral", 
    StringLiteral = "StringLiteral", 
    VariableNode = "VariableNode", 
    WhenNode = "WhenNode", 
    NumberLiteral = "NumberLiteral", 
}


export interface VariableNode extends LunaCodeNode {    
    name?: string | null;
}

export interface LiteralNode extends LunaCodeNode {
    value?: any | null;
}

export interface StringLiteral extends LiteralNode {

}

export interface NumberLiteral extends LiteralNode {

}

export interface NullLiteral extends LiteralNode {

}

export interface NotNode extends LunaCodeNode {
    
    child?: LunaCodeNode | null;
    
    
}

export interface LunaCodeError {
    
    
    message?: string | null;
}

export interface LikeNode extends LunaCodeNode {
    
    lhs?: LunaCodeNode | null;
    rhs?: LunaCodeNode | null;
    
    
}

export interface IsNullNode extends LunaCodeNode {
    
    lhs?: LunaCodeNode | null;
    
    
}

export interface InNode extends LunaCodeNode {
    
    expression?: LunaCodeNode | null;
    parameterList?: LunaCodeNode[] | null;
    
    
}

export interface IfNode extends LunaCodeNode {
    
    condition?: LunaCodeNode | null;
    trueResult?: LunaCodeNode | null;
    falseResult?: LunaCodeNode | null;
    
    
}

export interface FunctionNode extends LunaCodeNode {
    
    name?: string | null;
    parameterList?: LunaCodeNode[] | null;
    
    
}

export interface DateLiteral extends LiteralNode {

}

export interface CaseNode extends LunaCodeNode {    
    defaultValue?: LunaCodeNode | null;
    conditions?: WhenNode[] | null;
}

export interface BooleanLogicNode extends LunaCodeNode {
    
    lhs?: LunaCodeNode | null;
    operation?: string | null;
    rhs?: LunaCodeNode | null;
    
    
}

export interface BooleanLiteral extends LiteralNode {

}

export interface ArithmeticNode extends LunaCodeNode {
    
    lhs?: LunaCodeNode | null;
    operation?: string | null;
    rhs?: LunaCodeNode | null;
    
    
}

export interface ArgumentNode extends LunaCodeNode {
    
    name?: string | null;

}
